/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMoney = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 4v16H2V4zm-5.899 2H7.9A5.015 5.015 0 0 1 4 9.9v4.2A5.015 5.015 0 0 1 7.9 18h8.2a5.015 5.015 0 0 1 3.9-3.9V9.9A5.015 5.015 0 0 1 16.1 6zM20 16c-.851.302-1.526 1.148-1.828 2H20zm-16 .171V18h1.83A3.016 3.016 0 0 0 4 16.171zM12 8c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm8-4h-1.828c.302.852.977 1.698 1.828 2zM5.83 6H4v1.829A3.016 3.016 0 0 0 5.83 6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMoney as Money };
